module.exports = __webpack_public_path__ + "media/components/country-flag/static/pt-e9a7ca57f374995ab232eed4e994faf4.svg";